import {StorageKey} from "../../../../enums/StorageKey";
import {t} from "@lingui/macro";
import {
    ColRenderer,
} from "../../../../containers/AppPage/Reports/TransactionSummary/Common/helperColRenderer";
import {Type} from "../../../../redux/Transaction/helper";

function getColumns() {
    return [
        {
            title: t`Date`,
            dataIndex: 'date',
            key: 'date',
            sorter: true,
            onCell: ColRenderer.onCell,
            render: (text, record) => ColRenderer.renderDate(text, record, Type.sale_payment),
        },
        {
            title: t`Payment`,
            dataIndex: 'number',
            key: 'number',
            sorter: true,
            render: (text, record) => ColRenderer.renderNumber(text, record, Type.sale_payment),
        },
        {
            title: t`Contact`,
            dataIndex: 'contact_name',
            key: 'contact_name',
            sorter: true,
            render: ColRenderer.renderContact,
        },
        {
            title: t`Contact Code`,
            dataIndex: 'contact_code',
            key: 'contact_code',
            sorter: true,
        },
        {
            title: t`Phone No.`,
            dataIndex: 'phone_no',
            key: 'phone_no',
            render: ColRenderer.renderText,
        },
        {
            title: t`Ref No.`,
            dataIndex: 'number2',
            key: 'number2',
            sorter: true,
            render: ColRenderer.renderText,
        },
        {
            title: t`Tags`,
            dataIndex: 'tag_names',
            key: 'tag_names',
            ellipsis: true,
            render: ColRenderer.renderTags,
        },
        {
            title: t`Payment Method`,
            dataIndex: 'payment_method',
            key: 'payment_method',
            render: ColRenderer.renderText,
        },
        {
            title: t`Invoice Number`,
            dataIndex: 'invoice_number',
            key: 'invoice_number',
            render: ColRenderer.renderInvoiceNumber,
        },
        {
            title: t`Invoice Description`,
            dataIndex: 'invoice_description',
            key: 'invoice_description',
            ellipsis: true,
            render: ColRenderer.renderText,
        },
        {
            title: t`Ref Amt`,
            dataIndex: 'amount',
            key: 'amount',
            align: 'right',
            render: ColRenderer.renderAmount,
        },
        {
            title: t`Amt`,
            dataIndex: 'base_amount',
            key: 'base_amount',
            align: 'right',
            onCell: ColRenderer.onCell,
            render: ColRenderer.renderBaseAmount,
        },
        {
            title: t`Created`,
            dataIndex: 'created_at',
            key: 'created_at',
            sorter: true,
            width: 180,
            render: ColRenderer.renderCreatedAt,
        },
    ];
}

export default {
    storageKey: StorageKey.report_payment_summary,
    getReportLabel: () => t`Payment Summary`,
    required: [
        'date',
        'number',
        'invoice_number',
        'base_amount',
    ],
    defaulto: [
        'contact_name',
        'invoice_description',
    ],
    getColumns,
};
